import React from 'react';
import { Bert } from 'meteor/themeteorchef:bert';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import MapShareComponent from '../MapShareComponent';
import MapShareUserPrivateComponent from '../MapShareUserPrivateComponent';
import MapSharePrivateComponent from '../MapSharePrivateComponent';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import useTimeStore from '../ZustandProvider';
import MapShareUserPublicComponent from '../MapShareUserPublicComponent';
import MapShareByEmailMobile from '../MapShareByEmailMobile';

const MapShareTogether = props => {
  const { map, isPublicMap, shareOptions } = props;
  const centerMap = useTimeStore(state => state.centerMap);
  const setCenterMap = useTimeStore(state => state.setCenterMap);

  React.useEffect(() => {
    if (isEmpty(centerMap)) {
      setCenterMap({
        lat: map.mapLocation.geometry.coordinates[1],
        lng: map.mapLocation.geometry.coordinates[0],
        zoom: map.mapLocation.properties.zoom
      });
    }
  }, []);
  const toggleShared = async (mapId, isShared) => {
    try {
      await methodPromise('maps.toggleShared', mapId, !isShared);
      if (!isShared) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  const toggleSharedPrivate = async (mapId, isShared) => {
    try {
      await methodPromise('maps.toggleSharedPrivate', mapId, !isShared);
      if (!isShared) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const toggleSharedUser = async (mapId, isShared) => {
    try {
      await methodPromise('maps.toggleSharedUser', mapId, !isShared);
      if (!isShared) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const toggleSharedUserPrivate = async (mapId, isShared) => {
    try {
      await methodPromise('maps.toggleSharedUserPrivate', mapId, !isShared);
      if (!isShared) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const toggleWithLocation = async (mapId, isWithLocation) => {
    try {
      await methodPromise('maps.toggleWithLocation', mapId, !isWithLocation);
      if (!isWithLocation) {
        Bert.alert('Location Created', 'success');
      } else {
        Bert.alert('No longer Location', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  const toggleWithLocationPrivate = async (mapId, isWithLocationPrivate) => {
    try {
      await methodPromise('maps.toggleWithLocationPrivate', mapId, !isWithLocationPrivate);
      if (!isWithLocationPrivate) {
        Bert.alert('Location Private Created', 'success');
      } else {
        Bert.alert('No longer Location Private', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const toggleWithLocationUser = async (mapId, isWithLocationUser) => {
    try {
      await methodPromise('maps.toggleWithLocationUser', mapId, !isWithLocationUser);
      if (!isWithLocationUser) {
        Bert.alert('Location Private Created', 'success');
      } else {
        Bert.alert('No longer Location Private', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const toggleWithLocationUserPrivate = async (mapId, isWithLocationUserPrivate) => {
    try {
      await methodPromise('maps.toggleWithLocationUserPrivate', mapId, !isWithLocationUserPrivate);
      if (!isWithLocationUserPrivate) {
        Bert.alert('Location Private Created', 'success');
      } else {
        Bert.alert('No longer Location Private', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  return (
    <>
      {shareOptions && shareOptions.showPublicShare === true && (
        <>
          <MapShareComponent
            map={{ ...map }}
            toggleShared={toggleShared}
            location={centerMap}
            isPublicMap={isPublicMap}
            toggleWithLocation={toggleWithLocation}
          />
          {isPublicMap === true && (
            <MapShareComponent
              map={{ ...map }}
              toggleShared={toggleShared}
              location={centerMap}
              isPublicMap={isPublicMap}
              toggleWithLocation={toggleWithLocation}
            />
          )}
          <br />
        </>
      )}
      {shareOptions && shareOptions.showPrivateShare === true && (
        <>
          <MapSharePrivateComponent
            map={{ ...map }}
            toggleSharedPrivate={toggleSharedPrivate}
            location={centerMap}
            isPublicMap={isPublicMap}
            toggleWithLocationPrivate={toggleWithLocationPrivate}
          />
          {isPublicMap === true && (
            <MapSharePrivateComponent
              map={{ ...map }}
              toggleSharedPrivate={toggleSharedPrivate}
              location={centerMap}
              isPublicMap={isPublicMap}
              toggleWithLocationPrivate={toggleWithLocationPrivate}
            />
          )}
          <br />
        </>
      )}
      {shareOptions && shareOptions.showPublicUserShare === true && (
        <>
          <MapShareUserPublicComponent
            map={{ ...map }}
            toggleSharedUser={toggleSharedUser}
            location={centerMap}
            isPublicMap={isPublicMap}
            toggleWithLocationUser={toggleWithLocationUser}
          />
          {isPublicMap === true && (
            <MapShareUserPublicComponent
              map={{ ...map }}
              toggleSharedUser={toggleSharedUser}
              location={centerMap}
              isPublicMap={isPublicMap}
              toggleWithLocationUser={toggleWithLocationUser}
            />
          )}
          <br />
        </>
      )}
      {shareOptions && shareOptions.showPrivateUserShare === true && (
        <>
          <MapShareUserPrivateComponent
            map={{ ...map }}
            toggleSharedUserPrivate={toggleSharedUserPrivate}
            location={centerMap}
            isPublicMap={isPublicMap}
            toggleWithLocationUserPrivate={toggleWithLocationUserPrivate}
          />
          {isPublicMap === true && (
            <MapShareUserPrivateComponent
              map={{ ...map }}
              toggleSharedUserPrivate={toggleSharedUserPrivate}
              location={centerMap}
              isPublicMap={isPublicMap}
              toggleWithLocationUserPrivate={toggleWithLocationUserPrivate}
            />
          )}
          <br />
        </>
      )}
      {shareOptions &&
        shareOptions.showShareByEmailMobile &&
        shareOptions.showShareByEmailMobile === true && <MapShareByEmailMobile {...props} />}
    </>
  );
};

export default MapShareTogether;

MapShareTogether.defaultProps = {
  map: {},
  isPublicMap: false,
  shareOptions: {
    showPublicShare: true,
    showPrivateShare: true,
    showPublicUserShare: true,
    showPrivateUserShare: true,
    showShareByEmailMobile: true
  }
};

MapShareTogether.propTypes = {
  map: PropTypes.object,
  isPublicMap: PropTypes.bool,
  shareOptions: PropTypes.object
};
